import { render, staticRenderFns } from "./Anagrams.vue?vue&type=template&id=033396b4&"
import script from "./Anagrams.vue?vue&type=script&lang=js&"
export * from "./Anagrams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports